var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscussion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41667 8.33317H16.5833M7.41667 11.9998H11.0833M12 19.3332L8.33333 15.6665H5.58333C5.0971 15.6665 4.63079 15.4733 4.28697 15.1295C3.94315 14.7857 3.75 14.3194 3.75 13.8332V6.49984C3.75 6.01361 3.94315 5.54729 4.28697 5.20347C4.63079 4.85966 5.0971 4.6665 5.58333 4.6665H18.4167C18.9029 4.6665 19.3692 4.85966 19.713 5.20347C20.0568 5.54729 20.25 6.01361 20.25 6.49984V13.8332C20.25 14.3194 20.0568 14.7857 19.713 15.1295C19.3692 15.4733 18.9029 15.6665 18.4167 15.6665H15.6667L12 19.3332Z",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussion);
export default __webpack_public_path__ + "static/media/discussion.42b54f184b36c584be78f04bec07d536.svg";
export { ForwardRef as ReactComponent };